
import moment from 'moment';
import { longPurchaseOptionLabel } from "./generate-fund-codes";
import siteLanguage from "../siteLanguage";

moment.locale(siteLanguage);

// provide default classes and determine which color class to give
export const getNumericColClasses = (value) => {
	// defaults
	let classes = ['pr-4','py-4','align-middle','text-center'];
	if (!value) return classes.join(' ')
	if (value < 0) {
		classes.push('text-tableRed')
	} else {
		classes.push('text-tableGreen')
	}
	return classes.join(' ');
}


export const fillInDatesFromFirstItem = (hit) => {
	document.querySelector(".js-nav").innerHTML = moment(hit.primary.nav.date).format('ll');
	document.querySelector(".js-performance").innerHTML = moment(hit.primary.performance.date).format('ll');
}

export const buildAllFundCodes = (option) => {
	let additionalClass = "";
	if (option.purchaseOption) {
		if (option.purchaseOption.startsWith('DSC') || option.purchaseOption.startsWith('LL')) {
			additionalClass = 'opacity-50';
		}
	}

	return (
		`<div class="${additionalClass} my-1 hover:border-blueBrand hover:text-blueBrand">
			<a class="inline-block" href="/fund/${option.fundId}">
				${longPurchaseOptionLabel(option)}
			</a>
		</div>
		`
	)
}

/**
 *
 * Use the isPrimary flag to get the primary fundId
 * @param fund {object}
 */
export const getPrimaryFundId = (fund) => {
	let primaryFundId = "";
	for (let i = 0; i < fund.purchaseOptions.length; i++) {
		if (fund.purchaseOptions[i].isPrimary) {
			primaryFundId = fund.purchaseOptions[i].fundId;
			break;
		}
	}
	return primaryFundId
}
